import React from 'react';
import FooterTile from './FooterTile';
import LightRetouchTextLink from '@shared/light-retouch/components/LightRetouchTextLink/LightRetouchTextLink';
import {
    TypeButtonLinkComponentSkeleton,
    TypeButtonLinkComponentWithoutUnresolvableLinksResponse,
    TypeMegaMenuComponentWithoutUnresolvableLinksResponse,
    TypeMenuColumnHousingSkeleton,
    TypeMenuColumnHousingWithoutUnresolvableLinksResponse,
} from '@shared/features/contentful/_generated';
import { Entry } from 'contentful';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import { resolveContentfulTargetProps } from '@shared/features/contentful/linkMap';

interface IFooterMenuColumnProps {
    menuItems?: TypeMegaMenuComponentWithoutUnresolvableLinksResponse['fields']['items'];
    isMobile?: boolean;
}

interface RenderMenuColumnProps {
    columnData: Entry<
        TypeButtonLinkComponentSkeleton | TypeMenuColumnHousingSkeleton,
        'WITHOUT_UNRESOLVABLE_LINKS',
        string
    >;
    isMobile?: boolean;
}

const RenderMenuColumn: React.FC<RenderMenuColumnProps> = ({ columnData, isMobile }) => {
    const inspectorProps = useContentfulInspectorMode();

    if (columnData?.sys?.contentType?.sys?.id === 'menuColumnHousing') {
        const data = columnData as TypeMenuColumnHousingWithoutUnresolvableLinksResponse;

        return (
            <FooterTile
                key={data?.sys?.id}
                id={data?.sys?.id}
                title={data?.fields?.title ?? ''}
                isMobile={isMobile}
            >
                {data?.fields?.columns && (
                    <ul>
                        {data.fields.columns.map(
                            (item) =>
                                item && (
                                    <RenderMenuColumn
                                        key={item?.sys?.id}
                                        columnData={item}
                                        isMobile={isMobile}
                                    />
                                ),
                        )}
                    </ul>
                )}
            </FooterTile>
        );
    } else {
        // this is a button link
        const data = columnData as TypeButtonLinkComponentWithoutUnresolvableLinksResponse;
        return (
            <li
                key={data?.sys?.id}
                className="mb-2"
                {...inspectorProps({ fieldId: 'link', entryId: data?.sys?.id })}
            >
                {data?.fields?.title && (
                    <LightRetouchTextLink
                        href={data?.fields?.link ?? '/'}
                        showArrow={false}
                        variant="gold"
                        className="text-sm !font-[400] !text-colourForegroundSecondary"
                        prefetch={false}
                        {...resolveContentfulTargetProps(data?.fields?.target)}
                    >
                        {data.fields.title}
                    </LightRetouchTextLink>
                )}
            </li>
        );
    }
};

const FooterMenu: React.FC<IFooterMenuColumnProps> = ({ menuItems, isMobile }) => {
    return (
        menuItems?.map(
            (columnData) =>
                columnData && (
                    <RenderMenuColumn
                        key={columnData?.sys?.id}
                        columnData={columnData}
                        isMobile={isMobile}
                    />
                ),
        ) || null
    );
};

export default FooterMenu;
